<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Socso Contribution Rate"
      text="Edit Socso Contribution Rate"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localSocso.wages_from"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('from')"
              data-vv-name="from"                
              data-vv-as="From"      
              prefix="RM"          
              label="From"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localSocso.wages_to"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('to')"
              data-vv-name="to"                
              data-vv-as="To"  
              prefix="RM"          
              label="To"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localSocso.first_category_employer_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('first_category_employer_contribution')"
              data-vv-name="first_category_employer_contribution"                
              data-vv-as="First Category Employer Contribution"                
              label="First Category Employer Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localSocso.first_category_employee_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('first_category_employee_contribution')"
              data-vv-name="first_category_employee_contribution"                
              data-vv-as="First Category Employee Contribution"                
              label="First Category Employee Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localSocso.first_category_total_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('first_category_total_contribution')"
              data-vv-name="first_category_total_contribution"                
              data-vv-as="First Category Total Contribution"                
              label="First Category Total Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localSocso.second_category_employer_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('second_category_employer_contribution')"
              data-vv-name="second_category_employer_contribution"                
              data-vv-as="Second Category Employer Contribution"                
              label="Second Category Employer Contribution"
              prefix="RM"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      socso: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localSocso: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localSocso = { ...this.socso }
        this.localSocso.wages_from = (this.localSocso.wages_from / 100).toFixed(2)
        this.localSocso.wages_to = (this.localSocso.wages_to / 100).toFixed(2)
        this.localSocso.first_category_employer_contribution = (this.localSocso.first_category_employer_contribution / 100).toFixed(2)
        this.localSocso.first_category_employee_contribution = (this.localSocso.first_category_employee_contribution / 100).toFixed(2)
        this.localSocso.first_category_total_contribution = (this.localSocso.first_category_total_contribution / 100).toFixed(2)
        this.localSocso.second_category_employer_contribution = (this.localSocso.second_category_employer_contribution / 100).toFixed(2)
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.socso().update(this.localSocso.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.dialog = false 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          wages_from: this.localSocso.wages_from * 100,
          wages_to: this.localSocso.wages_to * 100,
          first_category_employer_contribution: this.localSocso.first_category_employer_contribution * 100,
          first_category_employee_contribution: this.localSocso.first_category_employee_contribution * 100,
          first_category_total_contribution: this.localSocso.first_category_total_contribution * 100,
          second_category_employer_contribution: this.localSocso.second_category_employer_contribution * 100,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
